module.exports = __webpack_public_path__ + "img/1191411985.747a66bb.jpg";